//styles
import "./styles.scss";

//component
import Button from "../Button";

function ReportComponent({
  headingName,
  reportName,
  referenceName,
  accessorName,
  sentOn,
  handleviewpastreports,
  handleviewlatestreports,
}) {
  return (
    <div className="report-container">
      <div className="report">
        <h3>{reportName} Report </h3>
        <div className="report-details">
          <div className="report-details-details">
            <p>
              Assessor Name &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>: {accessorName}</strong>
            </p>
            <p>
              Report Sent On &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong>: {sentOn}</strong>
            </p>
            <p>
              Reference Number &nbsp; <strong>: {referenceName}</strong>
            </p>
          </div>
          <div className="report-actions">
            <Button
              title="View Past Reports"
              buttonStyle={{
                fontSize: "1rem",
                backgroundColor: "white",
                border: "2px solid #1F2155",
                cursor: "pointer",
              }}
              titleStyle={{ fontSize: "1rem", color: "#002366" }}
              onClick={handleviewpastreports}
            />
            <Button
              title="View Latest Reports"
              buttonStyle={{ fontSize: "1rem" }}
              onClick={handleviewlatestreports}
              titleStyle={{ fontSize: "1rem", color: "white" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportComponent;
